import { render, staticRenderFns } from "./h-comment-list.vue?vue&type=template&id=64c571b2&scoped=true"
import script from "./h-comment-list.vue?vue&type=script&lang=js"
export * from "./h-comment-list.vue?vue&type=script&lang=js"
import style0 from "./h-comment-list.vue?vue&type=style&index=0&id=64c571b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c571b2",
  null
  
)

export default component.exports